import _ from 'lodash'

// Defined the product attribute use to render the simple product
const matrixMapping = [
  {
    label: 'Size',
    key: 'size',
    scriptId: 'custitem_bbs_item_size1',
    select: 'sizes',
    useToCombine: true
  },
  {
    label: 'Leg Length',
    key: 'legLength',
    scriptId: 'custitem_bbs_item_size2',
    select: 'legLengths',
    useToCombine: true
  },
  {
    label: 'Colour',
    key: 'color',
    scriptId: 'custitem_bbs_item_colour',
    select: 'colours',
    useToCombine: true
  },
  {
    label: 'Finish',
    key: 'finish',
    scriptId: 'custitem_bbs_item_finish_ref',
    select: 'finishs',
    useToCombine: true,
    related: ['custitem_bbs_item_finish_logo']
  },
  {
    label: 'Logo',
    key: 'logo',
    scriptId: 'custitem_bbs_item_finish_logo',
    select: 'logos',
    useToCombine: false
  }
]

/**
 * convertBasketItems
 * Convert the simple products from configurable product and the options
 * that user has already selected to add to basket
 * @param  [] products
 * @param  [] itemsSelected
 * @return []
 */
const convertBasketItems = (products, itemsSelected, employeeId = null) => {
  // Handle both array format and { data: [...] } format
  const productList = Array.isArray(products) ? products : (products?.data || [])

  if (0 == itemsSelected.length || 0 == productList.length) {
    return []
  }


  const basketItems = []

  if(itemsSelected && productList.length) {
    itemsSelected.map(o => {
      productList.map(product => {
        if (product.internalId == o.parentId) {
          // Debug: log parent product's simples count and first simple's MOQ fields
          console.log('[convertBasketItems] Parent product:', product.internalId,
            'simples count:', product.simples?.length || 0,
            'parent MOQ:', _.get(product, 'custitem_smi_item_reorder_mult.value'),
            'first simple MOQ:', _.get(product, 'simples[0].custitem_smi_item_reorder_mult.value'));

          let simple = _.cloneDeep(
              product.simples.find(sim => sim.internalId == o.productId)
          )

          if (simple) {
            // Debug: log the simple's MOQ fields at time of find
            console.log('[convertBasketItems] Simple found for productId:', o.productId,
              'has custitem_smi_item_reorder_mult:', !!simple.custitem_smi_item_reorder_mult,
              'value:', _.get(simple, 'custitem_smi_item_reorder_mult.value'),
              'has custitem_smi_mysmi_item_msq:', !!simple.custitem_smi_mysmi_item_msq,
              'value:', _.get(simple, 'custitem_smi_mysmi_item_msq.value'));

            // IN CASE: Apply for manpack
            if (employeeId) {
              simple.employeeId = employeeId
              simple.manpack = true
            }

            simple.id = simple.internalId
            simple.productId = o.productId  // Preserve productId from basket state for updates
            simple.qty = o.qty
            simple.displayName = product.displayName
            simple.custitem_bbs_default_product_image =
                product.custitem_bbs_thumb_webpath_vias3_frnt ||
                product.custitem_bbs_default_product_image ||
                simple.custitem_bbs_default_product_image
            simple.parentId = product.internalId
            // Copy inactive status - from basket item OR from parent product
            if (o.isInactive === true || product.isInactive === true) {
              simple.isInactive = true
            }
            if (o.custitem_smi_mysmi_remove_item?.value === true || product.custitem_smi_mysmi_remove_item?.value === true) {
              simple.custitem_smi_mysmi_remove_item = o.custitem_smi_mysmi_remove_item || product.custitem_smi_mysmi_remove_item
            }
            simple.matrixItemNameTemplate = product.matrixItemNameTemplate
            simple.simples = product.simples
            simple = additionalMatrixMapping(simple, product)
            simple.editing = o.editing || false
            simple.options = o.options || {}

            // For manpack: use employee-specific budget data
            if (employeeId && simple.budgetsByEmployee && simple.budgetsByEmployee[employeeId]) {
              const empBudget = simple.budgetsByEmployee[employeeId]
              simple.budget = empBudget
              simple.allocationType = empBudget.allocationType
              simple.itemPoints = empBudget.itemPoints

              // Get budget metadata from product.budgetsByEmployee
              if (product.budgetsByEmployee && product.budgetsByEmployee[employeeId]) {
                simple.budgetType = product.budgetsByEmployee[employeeId].budgetType
                simple.budgets = product.budgetsByEmployee[employeeId].budgets
                simple.pointsMultiplier = product.budgetsByEmployee[employeeId].pointsMultiplier
              }
            } else {
              // For stock orders: use single budget
              // Use simple's own allocationType if it exists, otherwise fall back to parent's
              simple.allocationType = simple.allocationType || product.allocationType

              // Get itemPoints from the simple's own budget data if available
              // This is important for points budget users
              if (simple.budget && simple.budget.itemPoints) {
                simple.itemPoints = simple.budget.itemPoints
              } else if (product.pointsMultiplier && simple.price) {
                // Fallback: calculate from price * multiplier
                simple.itemPoints = Math.round(parseFloat(simple.price) * product.pointsMultiplier)
              } else {
                // Otherwise copy from parent as fallback
                simple.itemPoints = product.itemPoints
              }

              // Copy budget metadata from parent product to basket item
              if (product.budgetType) {
                simple.budgetType = product.budgetType
              }
              if (product.budgets) {
                simple.budgets = product.budgets
              }
              if (product.pointsMultiplier) {
                simple.pointsMultiplier = product.pointsMultiplier
              }
            }

            // Validation data - check simple first, then fall back to parent product
            console.log('[convertBasketItems] MOQ data - simple.custitem_smi_item_reorder_mult:', _.get(simple, 'custitem_smi_item_reorder_mult'), 'product.custitem_smi_item_reorder_mult:', _.get(product, 'custitem_smi_item_reorder_mult'));
            console.log('[convertBasketItems] MOQ data - simple.custitem_smi_mysmi_item_msq:', _.get(simple, 'custitem_smi_mysmi_item_msq'), 'product.custitem_smi_mysmi_item_msq:', _.get(product, 'custitem_smi_mysmi_item_msq'));
            simple.quantityStep = _.get(simple, 'custitem_smi_item_reorder_mult.value')
                ? parseInt(_.get(simple, 'custitem_smi_item_reorder_mult.value'))
                : _.get(product, 'custitem_smi_item_reorder_mult.value')
                    ? parseInt(_.get(product, 'custitem_smi_item_reorder_mult.value'))
                    : 1
            simple.minimumSaleQuantity = _.get(simple, 'custitem_smi_mysmi_item_msq.value')
                ? parseInt(_.get(simple, 'custitem_smi_mysmi_item_msq.value'))
                : _.get(product, 'custitem_smi_mysmi_item_msq.value')
                    ? parseInt(_.get(product, 'custitem_smi_mysmi_item_msq.value'))
                    : 1
            console.log('[convertBasketItems] Final values - quantityStep:', simple.quantityStep, 'minimumSaleQuantity:', simple.minimumSaleQuantity);

            // Simple data


            if (product.matrixOptionList?.length) {
              product.matrixOptionList.forEach((option) => {
                if (
                    option.matrixOption &&
                    option.matrixOption.$attributes &&
                    option.matrixOption.$attributes.name ===
                    "custitem_bbs_item_colour"
                ) {
                  simple.color = option.matrixOption.value?.name || null;
                }
              });
            }

            const matrixAttributes = []
            const options = []
            matrixAttributes.push('custitem_bbs_item_colour')
            matrixAttributes.push('custitem_bbs_item_size1')
            matrixAttributes.push('custitem_bbs_item_size2')
            matrixAttributes.push('custitem_bbs_item_finish_ref')
            matrixAttributes.push('custitem_bbs_item_finish_logo')


            if (simple.matrixOptionList) {
              simple.matrixOptionList.matrixOption
                  .filter(matrix =>
                      matrixAttributes.includes(_.get(matrix, '$attributes.scriptId'))
                  )
                  .map(matrix => {
                    const name = _.get(matrix, '$attributes.scriptId')
                    const value = _.get(matrix, 'value.name')

                    if (name && value) {
                      options.push({name, value})
                    }
                  })
            }

            options.forEach(singleOption => {
              simple[singleOption.name] = singleOption.value
            })

            if (simple.price != o.price && o.price > 0) {
              simple.price = o.price
            }

            for (let key in simple.options) {
              simple[key] = simple.options[key]
            }

            basketItems.push(simple)
          } else {
            const item = {...o, ...product}
            item.displayName = product.displayName
            item.itemId = product.itemId
            item.id = item.internalId
            item.custitem_bbs_default_product_image =
                product.custitem_bbs_default_product_image ||
                product.custitem_bbs_thumb_webpath_vias3_frnt

            if (product.price != o.price && o.price) {
              item.price = o.price
            } else {
              item.price = product.price
            }

            item.options = o.options || {}

            // Preserve inactive status from basket item or product
            if (o.isInactive === true || product.isInactive === true) {
              item.isInactive = true
            }
            if (o.custitem_smi_mysmi_remove_item?.value === true || product.custitem_smi_mysmi_remove_item?.value === true) {
              item.custitem_smi_mysmi_remove_item = o.custitem_smi_mysmi_remove_item || product.custitem_smi_mysmi_remove_item
            }

            if (employeeId) {
              item.employeeId = employeeId
              item.manpack = true
            }

            // Validation data for non-simple products
            item.quantityStep = _.get(product, 'custitem_smi_item_reorder_mult.value')
                ? parseInt(_.get(product, 'custitem_smi_item_reorder_mult.value'))
                : 1
            item.minimumSaleQuantity = _.get(product, 'custitem_smi_mysmi_item_msq.value')
                ? parseInt(_.get(product, 'custitem_smi_mysmi_item_msq.value'))
                : 1

            for (let key in item.options) {
              item[key] = item.options[key]
            }

            basketItems.push({...item})
          }
        }
      })
    })
  }

  return basketItems
}

/**
 * additionalMatrixMapping
 * Simple add the attribute from the configurable product
 * @param  {} simple
 * @param  {} product
 * @return {}
 */
const additionalMatrixMapping = (simple, product) => {
  if (!simple.matrixOptionList?.matrixOption) {
    return simple;
  }

  matrixMapping.forEach((matrix) => {
    if (matrix.scriptId === "custitem_bbs_item_finish_ref") {
      // Find matching finish from product based on attribute internalId
      const attrVal = simple.matrixOptionList.matrixOption.find(
          (opt) => opt.$attributes?.scriptId === matrix.scriptId
      );

      const finishVal = product.custitem_bbs_item_finish_ref?.value?.find(
          (val) => val.$attributes?.internalId === attrVal?.value?.$attributes?.internalId
      );

      simple[matrix.key] = finishVal?.$attributes?.internalId || null;
      simple[`${matrix.key}Text`] = finishVal?.name || null;
    } else {
      // Standard attribute mapping from simple.matrixOptionList
      const attrVal = simple.matrixOptionList.matrixOption.find(
          (opt) => opt.$attributes?.scriptId === matrix.scriptId
      );

      simple[matrix.key] = attrVal?.value?.$attributes?.internalId || null;
      simple[`${matrix.key}Text`] = attrVal?.value?.name || null;
    }
  });

  return simple;
};

/**
 * determinedMatrixAttribute
 * Determinced attribute use to combine the simple product
 * @param  string matrixItemNameTemplate
 * @return []
 */
const determinedMatrixAttribute = (product, incl, excl) => {

  let matrixItemNameTemplate = product.matrixItemNameTemplate
  incl = incl || []
  excl = excl || []

  if (!Array.isArray(incl)) {
    incl = [incl]
  }

  // Remove colour for finished product
  // if (product['custitem_bbs_item_finish_ref']) {
  //   excl.push('custitem_bbs_item_colour')
  // }

  // Get matrix attribute code
  const attributeCode = matrixMapping
    .filter(
      matrix =>
        (matrix.useToCombine === true || incl.includes(matrix.scriptId)) &&
        product[matrix.scriptId] &&
        !excl.includes(matrix.scriptId)
    )
    .map(matrix => matrix.scriptId)

  // Determince attribute use to combine product simple
  const matrixItemNameTemplateAttribute = matrixNameTemplateSplit(
    matrixItemNameTemplate
  )
  matrixItemNameTemplate = attributeCode.filter(
    o => matrixItemNameTemplateAttribute.includes(o),
    matrixItemNameTemplateAttribute
  )

  return matrixItemNameTemplate.length > 0 ? matrixItemNameTemplate : []
}

const matrixNameTemplateSplit = matrixItemNameTemplate => {
  matrixItemNameTemplate = matrixItemNameTemplate
    ? matrixItemNameTemplate.split('-').map(o => o.replace(/(\{|\})/gm, ''))
    : ''

  return additionalDependencyMatrixAttribute(matrixItemNameTemplate)
}

const additionalDependencyMatrixAttribute = matrixAttributes => {
  matrixAttributes = !Array.isArray(matrixAttributes)
    ? [matrixAttributes]
    : matrixAttributes

  matrixMapping.map(matrix => {
    if (matrixAttributes.includes(matrix.scriptId) && matrix.depends) {
      matrixAttributes = matrixAttributes.concat(matrix.depends)
      matrixAttributes = [...new Set(matrixAttributes)]
    }
  })

  return matrixAttributes
}

function isParentProduct(product) {
  return (
    product.matrixType === '_parent' ||
    (!product.matrixType && product.matrixItemNameTemplate)
  )
}

/**
 * determinedSimpleProduct
 * Determined the simple product matrix attribute
 * @param  {} product
 * @return {} | boolean
 */
const determinedSimpleProduct = product => {
  if (
    !product.simples ||
    (!product.simples.length && !isParentProduct(product))
  ) {
    return product
  }

  const matrixAttributeRequired = determinedMatrixAttribute(product)

  return product.simples.find(simple => {
    const options = simple.matrixOptionList.matrixOption.filter(opt => {
      const matrixOption = matrixMapping.find(
        o => o.scriptId == opt.$attributes.scriptId
      )

      if (
        !matrixOption ||
        !matrixAttributeRequired.includes(matrixOption.scriptId) ||
        product[matrixOption.key] != opt.value.$attributes.internalId
      ) {
        return false
      }

      return true
    })

    return options && options.length == matrixAttributeRequired.length
  })
}

const getAttributesRelated = () => {
  const scriptIds = {}
  const related = {}
  matrixMapping.map(matrix => {
    if (matrix.related) {
      matrix.related.map(scriptId => (scriptIds[scriptId] = true))
    }
  })

  for (let scriptId in scriptIds) {
    matrixMapping.map(matrix => {
      if (matrix.scriptId == scriptId) {
        related[matrix.key] = matrix
      }
    })
  }

  return related
}

const getMatrixMappings = matrixScriptIds => {
  if (!Array.isArray(matrixScriptIds)) {
    matrixScriptIds = [matrixScriptIds]
  }

  return matrixMapping.filter(matrix =>
    matrixScriptIds.includes(matrix.scriptId)
  )
}

export {
  convertBasketItems,
  matrixMapping,
  determinedMatrixAttribute,
  determinedSimpleProduct,
  matrixNameTemplateSplit,
  getAttributesRelated,
  getMatrixMappings
}
